// extracted by mini-css-extract-plugin
module.exports = {"input":"TextAreaInput_input__1m3WY","error":"TextAreaInput_error__T3zRN"};